import React, { FC, useContext, useEffect, useRef, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
import {
  ArrowLeft,
  ArrowRight,
  BookOpenIcon,
  CalendarIcon,
  ClockIcon,
  X,
} from "lucide-react";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import { ChevronRight } from "lucide-react";


import toast from "react-hot-toast";
import { ExamsTypes } from "../../../interfaces/exams.interface";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { baseServiceUrl, ServerStatus, urls } from "../../../environment";

import { ExaminationSlide } from "../ExaminationSlide";
import { Button } from "@mui/material";
import {
  convertTo12Hour,
  decryptAES256CBC,
  decryptAES256CBC2,
  encryptWithFixedKey,
  formatDateTime,
  generateRandomBytes,
  isCameraAvailable,
  startClockFromInput,
} from "../../../utils";

import PageLoader from "../../../components/Loader/PageLoader";
import useUserStore from "../../../stores/useUserStores";
import { UserContext } from "../../../context/UserContext";
import useExamStores from "../../../stores/useExamStores";

type MyExamsSectionProps = {};
const MyExamsSection: FC<MyExamsSectionProps> = (): JSX.Element => {
  const errornotify = (msg: any) => toast.error(msg);
  const TimeMountRef = useRef<boolean>(false);
  const location = useLocation();
  const [examsPageIndex, setExamsPageIndex] = useState<number>(0);
  const [examsPageSize, setExamsPageSize] = useState<number>(6);
  const [rows, setRows] = useState<Array<any>>([]);
  const [examsets, setexamsets] = useState<ExamsTypes>({
    total_count: 0,
    page_index: 0,
    page_size: 0,
    count: 0,
    resp: [],
    current_datetime: "",
  });
  const CurrentTimerRef = useRef<any>(null);
  const [currentTime, setCurrentTime] = useState<{
    date: string;
    time: string;
  }>({
    date: "",
    time: "",
  });
  // const setCurrentTime = ({ date, time }: { date: string; time: string }) => {
  //   currentTime.current = { date, time };
  // };

  // const currentTime = useRef<{
  //   date: string;
  //   time: string;
  // }>({
  //   date: "",
  //   time: "",
  // });
  const Navigate = useNavigate();

  const {
    userdetail,
    setLoading,
    token,
    fullscreenmode,
    setFullScreenMode,
    setExam,
    exam,
    setExamStarted,
    examStarted,
    examQuestionDetails,
    setExamQuestionDetails,
    setStartExamMessage,
    loading,
    startExamMessage,

    resumeDuration,
    setResumeDuration,
  } = useUserStore();
  const { handleFullscreenChange, enterFullscreen }: any =
    useContext(UserContext);
  const ExamContext = useExamStores();

  const [searchedText, setSearchText] = useState<string>("");
  const handleChangePage = (event: unknown, newPage: number) => {
    setExamsPageIndex(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setExamsPageSize(+event.target.value);
    setExamsPageIndex(0);
  };


    useEffect(() => {
      if (ServerStatus === "OFFLINE") return;
      (async () => {
        const cameraAvailable = await isCameraAvailable();
        ExamContext.setCameraFound(cameraAvailable);
      })();
    }, [exam,  ServerStatus]);

  useEffect(() => {
    if (!userdetail) return;
    (async () => {
      try {
        setLoading(true);

        const response = await axios.post(
          baseServiceUrl + urls.getAllExamUrl,
          {
            search_string: "SA",
            page_index: examsPageIndex,
            page_size: examsPageSize,
            user_type: "Examinee",
            user_id: userdetail.id,
            email: userdetail.email,
          },
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        );
        if (response.data) {
          setexamsets(response.data);
        }

        setLoading(false);
      } catch (err: any) {
        setLoading(false);
        errornotify(
          err?.response?.data?.message || "Error encounter. Please try again."
        );
      }
    })();
  }, [userdetail, examsPageIndex]);

  //  *************************  Resume Test ************************************
  const resumeTest = (item: any) => {
    (async () => {
      try {
        const encryption_key = generateRandomBytes();
        setLoading(true);
        let rawPayload = {
          exam_id: item.id,
          user_id: userdetail.id,
          encryption_key,
          face_verified: ExamContext.faceVerfied,
        };
        const payload = encryptWithFixedKey(rawPayload);
        const response = await axios.post(
          baseServiceUrl + urls.resumeExam,
          payload,
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        );
        if (response.data) {
          const rawResponse = await decryptAES256CBC2(
            response.data?.response,
            btoa(encryption_key)
          );
          const responsedData = JSON.parse(rawResponse);
          if (responsedData?.proctor_token) {
            ExamContext.setProctorAuthToken(responsedData?.proctor_token ?? "");
          }
          enterFullscreen?.();
          handleFullscreenChange?.();

          setExamStarted(true);
          setLoading(true);
          setStartExamMessage(
            responsedData?.message ?? "Examination resumed successfully"
          );

          setExam({
            ...exam,

            ...item,
            exam_session: responsedData?.session_id,
          });

          //  ToDo:// *************************************   need to discuss with sajal daa *********************************************
          if (responsedData && responsedData?.duration)
            setResumeDuration(responsedData?.duration);
          if (
            responsedData &&
            responsedData?.questions &&
            Array.isArray(responsedData?.questions)
          ) {
            const _tempQuestions = responsedData.questions.map((self: any) => ({
              ...self,
              ans_id: self?.selected_option,
              status: self?.question_status,
            }));
            const _tempDetails = JSON.parse(
              JSON.stringify({ ...responsedData, questions: _tempQuestions })
            );
            setExamQuestionDetails(_tempDetails);
          } else {
            setExamQuestionDetails(responsedData);
          }

          Navigate("/test/ongoing");
        }

        setLoading(false);
      } catch (err: any) {
        setLoading(false);
        errornotify(
          err?.response?.data?.message || "Error encounter. Please try again."
        );
      }
    })();
  };

  // **********************  Start Test ***********************************

  const startTest = (item: any) => {
    (async () => {
      try {
        setLoading(true);
        const encryption_key = generateRandomBytes();
        setLoading(true);
        let rawPayload = {
          exam_id: item.id,
          user_id: userdetail.id,
          encryption_key,
          face_verified: ExamContext.faceVerfied,
        };
        const payload = encryptWithFixedKey(rawPayload);
        const response = await axios.post(
          baseServiceUrl + urls.examStartUrl,
          payload,
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        );
        if (response.data) {
          const rawResponse = await decryptAES256CBC2(
            response.data?.response,
            btoa(encryption_key)
          );
          const responsedData = JSON.parse(rawResponse);

          if (responsedData?.proctor_token) {
            ExamContext.setProctorAuthToken(responsedData?.proctor_token ?? "");
          }
          enterFullscreen?.();
          handleFullscreenChange?.();

          setExamStarted(true);
          setStartExamMessage(
            response?.data?.message ?? "Examination started successfully"
          );

          setExam({
            ...exam,
            ...item,
            exam_session: responsedData?.session_id,
          });
          setExamQuestionDetails(responsedData);
          Navigate("/test/ongoing");
        }

        setLoading(false);
      } catch (err: any) {
        setLoading(false);
        errornotify(
          err?.response?.data?.message || "Error encounter. Please try again."
        );
      }
    })();
  };

  useEffect(() => {
    if (examsets.current_datetime && !TimeMountRef.current) {
      const result = formatDateTime(examsets.current_datetime);
      TimeMountRef.current = true;

      const timer = setTimeout(() => {
        setCurrentTime(result);
      }, 1000);
      return () => {
        if (timer) clearTimeout(timer);
      };
    }
  }, [examsets]);

  useEffect(() => {
    if (currentTime?.date && currentTime?.time) {
      CurrentTimerRef.current = startClockFromInput({
        input: currentTime,
        setInput: setCurrentTime,
      });

      // return () => {
      //   if (timer) clearInterval(timer);
      // };
    }
  }, [examsets, currentTime?.date]);
  useEffect(() => {
    if (location.pathname !== "/dashboard/my-exams") {
      if (CurrentTimerRef.current) {
        clearInterval(CurrentTimerRef.current);
      }
    }
  }, []);
  console.log("hit >>>>>>>>> candidate machine  ");
  
  if (loading) return <PageLoader loading />;
  return (
    <div className="grid grid-cols-12 pb-10 mt-5">
      <div className="col-span-12 mb-2 ">
        <div className="px-4 w-full">
          <div className="flex justify-between items-center bg-gray-100 px-5 py-2 rounded-t-lg border border-gray-100 shadow-sm">
            <div className="w-full bg-white rounded-lg border border-gray-100 shadow-xs p-5">
              <div className="flex flex-col space-y-4 md:flex-row md:items-center md:justify-between md:space-y-0">
                {/* Left Content */}
                <div className="flex items-start space-x-4">
                  {/* Icon */}
                  <div className="mt-1 p-2.5 bg-blue-50 rounded-lg">
                    <BookOpenIcon className="h-5 w-5 text-blue-600" />
                  </div>

                  <div>
                    {/* Title */}
                    <div className="flex items-center gap-x-2">
                      <h2 className="text-xl font-semibold text-gray-900">
                        My Exams
                      </h2>
                    </div>

                    {/* Info Row */}
                    <div className="mt-2 flex flex-wrap items-center gap-3">
                      {/* Date */}
                      {examsets.current_datetime && currentTime?.date ? (
                        <div className="flex items-center space-x-1.5">
                          <CalendarIcon className="h-4 w-4 text-gray-400" />
                          <span className="text-sm text-gray-600">
                            {examsets.current_datetime ? currentTime?.date : ""}
                          </span>
                        </div>
                      ) : (
                        <></>
                      )}

                      {/* Time */}
                      {examsets.current_datetime && currentTime?.time ? (
                        <div className="flex items-center space-x-1.5">
                          <ClockIcon className="h-4 w-4 text-gray-400" />
                          <span className="text-sm text-gray-600">
                            {examsets.current_datetime && currentTime?.time
                              ? convertTo12Hour(
                                  currentTime?.time.replace(/AM|PM/, "")
                                )
                              : ""}
                          </span>
                        </div>
                      ) : (
                        <></>
                      )}

                      {/* Exams Badge */}
                    </div>
                  </div>
                </div>

                {/* CTA Button */}
              </div>
            </div>
            {/* <div className="  flex items-center relative w-[350px]  ">
              <input
                type="text"
                value={searchedText}
                onChange={(event: any) => (
                  setSearchText(event.target.value)
                  // requestSearch(event.target.value)
                )}
                className="py-2 rounded-tl-md rounded-bl-md w-[97%] pr-12 border px-3 focus:border-blue-500 outline-none "
                placeholder="Search Exams Here..."
              />
              {searchedText.length ? (
                <X
                  className="size-5 absolute top-[25%] text-gray-500 right-[25%] cursor-pointer"
                  onClick={cancelSearch}
                />
              ) : (
                <></>
              )}

              <div
                className="w-[80px] h-full py-[1px] flex items-center justify-center rounded-tr-md rounded-br-md cursor-pointer bg-[#2563EB]"
                onClick={() => requestSearch(searchedText.trim())}
              >
                <IconButton>
                  <SearchIcon sx={{ color: "#fff" }} />
                </IconButton>
              </div>
            </div> */}
          </div>
          <div className="bg-gray-50/50 px-5 py-6 rounded-b-lg border border-gray-100 border-t-0">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-5">
              {!!examsets &&
                examsets?.resp &&
                examsets?.resp.map((exam, key) => (
                  <ExaminationSlide
                    details={exam}
                    indexNum={key}
                    key={key}
                    startTest={startTest}
                    resumeTest={resumeTest}
                    currentDateTime={examsets.current_datetime}
                    currentTime={currentTime}
                  />
                ))}
              {examsets.count === 0 ? (
                <div className="mt-[15vh] text-gray-700 text-center w-full col-span-12">
                  No Exam Found
                </div>
              ) : loading ? (
                <div className="mt-[15vh] text-gray-700 text-center w-full col-span-12">
                  Please wait we are fetching the result ......
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="col-span-12   ">
        <div className=" mt-2 mx-auto  md:w-[95%] w-[80%]  flex items-center md:justify-end justify-between gap-x-2   bg-white  ">
          {examsets?.total_count &&
            examsets?.total_count > examsPageIndex &&
            examsPageIndex > 0 && (
              <button
                onClick={() => setExamsPageIndex((prev) => prev - 1)}
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-2 rounded-lg font-semibold flex items-center justify-center space-x-2 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
              >
                <ArrowLeft className="h-5 w-5" />
                <span className="hidden sm:block">Prev</span>
              </button>
            )}
          {examsets?.total_count &&
            examsets?.total_count >
              examsPageSize * examsPageIndex + examsPageSize &&
            examsets?.resp?.length && (
              <button
                onClick={() => setExamsPageIndex((prev) => prev + 1)}
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-2 rounded-lg font-semibold flex items-center justify-center space-x-2 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
              >
                <span className="hidden sm:block">Next</span>
                <ArrowRight className="h-5 w-5" />
              </button>
              // <Button
              //   variant="contained"
              //   className=""
              //
              //   endIcon={<KeyboardArrowRightIcon />}
              // >
              //   next
              // </Button>
            )}
          {/* {
              !!examsets && examsets
            }
               */}
        </div>
      </div>
    </div>
  );
};

export default MyExamsSection;
